import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
    PieChart,
    Pie,
    Cell,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from 'recharts';

interface ProductData {
    product_name: string;
    total_sold: number;
}

// Updated softer colors
const COLORS = ['#5271ff', '#74b9ff', '#55efc4', 'orange', '#fab1a0'];

const TopSellingProductsPieChart: React.FC = () => {
    const [topSellingProducts, setTopSellingProducts] = useState<ProductData[]>([]);

    useEffect(() => {
        const fetchTopSellingProducts = async () => {
            try {
                const response = await axios.get('https://api.sominnovations.xyz/Branches/top_selling_products/');
                setTopSellingProducts(response.data);
            } catch (error) {
                console.error('Error fetching top-selling products:', error);
            }
        };

        fetchTopSellingProducts();
    }, []);

    return (
        <div className="">
            <div className="row">
                <div className="col-12">
                    <div
                        className="card"
                        style={{
                            borderRadius: '12px',
                            backgroundColor: '#FFFFFF',
                            padding: '20px',
                        }}
                    >
                        <div className="card-body">
                            <h5
                                className="card-title text-center mb-4"
                                style={{
                                    fontWeight: 600,
                                    fontSize: '1.5rem',
                                    color: '#5271ff',
                                }}
                            >
                                Top Selling Products (Current Month)
                            </h5>
                            <div style={{ width: '100%', height: 400 }}>
                                <ResponsiveContainer>
                                    <PieChart>
                                        <Pie
                                            data={topSellingProducts}
                                            dataKey="total_sold"
                                            nameKey="product_name"
                                            cx="50%"
                                            cy="50%"
                                            outerRadius={150}
                                            innerRadius={60}
                                            label={({ name, percent }: any) =>
                                                `${name} (${(percent * 100).toFixed(1)}%)`
                                            }
                                            labelLine={false}
                                        >
                                            {topSellingProducts.map((_, index) => (
                                                <Cell
                                                    key={`cell-${index}`}
                                                    fill={COLORS[index % COLORS.length]}
                                                />
                                            ))}
                                        </Pie>
                                        <Tooltip
                                            contentStyle={{
                                                borderRadius: '8px',
                                                border: '1px solid #dee2e6',
                                                backgroundColor: '#ffffff',
                                                padding: '8px',
                                            }}
                                            labelStyle={{ fontWeight: 600, color: '#343a40' }}
                                        />
                                        <Legend
                                            layout="horizontal"
                                            align="center"
                                            verticalAlign="bottom"
                                            wrapperStyle={{
                                                paddingTop: '20px',
                                                fontSize: '14px',
                                                color: '#495057',
                                            }}
                                        />
                                    </PieChart>
                                </ResponsiveContainer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TopSellingProductsPieChart;
